module.exports = __webpack_public_path__ + "img/white-collection.92368621.svg";